/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" */
import { css } from 'styled-components';

import { PasswordInputProps } from './index';

/**
 * Base styles for the password input component
 */
const baseStyles = () => css`
    position: relative;

    .toggle-button {
        position: absolute;
        right: var(--layout-spacing-12);
        top: 3.2rem;
        z-index: 5;
        font-size: 1.2rem;

        .button-container {
            height: initial;
            padding: 0.6rem 0;
        }
    }

    .password-input input {
        padding-right: 5.6rem;
    }
`;

const disabledStyles = ({ disabled }: PasswordInputProps) => {
    if (!disabled) {
        return css``;
    }

    return css`
        .toggle-button {
            .button-label {
                color: var(--colors-text-tertiary);
                -webkit-text-fill-color: var(--colors-text-tertiary);
                -moz-text-fill-color: var(--colors-text-tertiary);
                background-image: none;
            }
        }
    `;
};

const errorStyles = ({
    forceError,
    error,
    touched,
    disabled,
}: PasswordInputProps) => {
    const showErrors = (error && touched) || forceError;
    if (!showErrors || disabled) {
        return css``;
    }

    return css`
        .toggle-button {
            .button-label {
                color: var(--colors-state-error);
                -webkit-text-fill-color: var(--colors-state-error);
                background-image: none;
            }
        }
    `;
};

/**
 * The password input component styles
 *
 * @param {PasswordInputProps} props The password input properties object
 * */
export const styles = (props: PasswordInputProps) => css`
    ${baseStyles()}
    ${errorStyles(props)}
    ${disabledStyles(props)}
`;
